import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { FontAwesomeKitIcon } from "./FontAwesomeKitIcon";
export const Icon = ({ iconSet, icon, size = 24, color = "#000", style, cssStyle, }) => {
    if (iconSet === "font-awesome") {
        return (<FontAwesomeKitIcon name={icon} size={size} color={color} style={style ?? "solid"} cssStyle={cssStyle}/>);
    }
    else if (iconSet === "material") {
        return (<MaterialIcons name={icon} size={size} color={color} style={cssStyle}/>);
    }
    else if (iconSet === "material-community") {
        return (<MaterialCommunityIcons name={icon} size={size} color={color} style={cssStyle}/>);
    }
    else {
        const CustomIcon = icon;
        return <CustomIcon size={size} color={color} style={cssStyle}/>;
    }
};
//# sourceMappingURL=Icon.js.map